import { BoxShadowClasses_BoxShadowClass_$ctor_Z207A3CFB } from "../Types/BoxShadow.fs.js";
import { Property_CssProperty } from "../Types/MasterTypes.fs.js";

export const BoxShadow = BoxShadowClasses_BoxShadowClass_$ctor_Z207A3CFB(new Property_CssProperty(62));

